<div class="section-container flex justify-center flex-col">
    <div class="text-section flex items-center">
        <div class="text-title flex flex-col">
            <span class="title">Team Members</span>
            <span class="sub-title"> cooperative and reliable.</span>
        </div>
        <div class="content">Behind every project are teams of creative minds and dedicated hearts. Here’s a closer look at the people who make it all happen.</div>
    </div>
    <div class="tabs flex justify-between">
        <button *ngFor="let tab of tabs" [id]="tab.id" [class.active]="selectedTab === tab.name" (click)="selectTab(tab)">
            {{ tab.name }}
        </button>
    </div>
    <div
        class="avatar-list avatar-list-desktop"
        [ngClass]="{
            'avatar-list-fixed-height': !isTotalCountLessThan25,
            'avatar-list-auto-height': isTotalCountLessThan25,
        }"
    >
        <div class="row" *ngFor="let teamMemberRow of allTeamMembersGridForDesktop">
            <div class="avatar-item" *ngFor="let teamMember of teamMemberRow">
                <img class="avatar" src="{{ teamMember.avatar }}" />
                <span class="name">{{ teamMember.name }}</span>
                <span class="title">{{ teamMember.title }}</span>
            </div>
        </div>
    </div>
    <div
        class="avatar-list avatar-list-mobile"
        [ngClass]="{
            'avatar-list-fixed-height': !isTotalCountLessThan15,
            'avatar-list-auto-height': isTotalCountLessThan15,
        }"
    >
        <div class="row" *ngFor="let teamMemberRow of allTeamMembersGridForMobile">
            <div class="avatar-item" *ngFor="let teamMember of teamMemberRow">
                <img class="avatar" src="{{ teamMember.avatar }}" />
                <span class="name">{{ teamMember.name }}</span>
                <span class="title">{{ teamMember.title }}</span>
            </div>
        </div>
    </div>
    <div class="flex justify-center items-center view-all-container view-all-container-desktop" *ngIf="totalCount > MAX_RESULT_COUNT_FOR_DESKTOP">
        <div class="flex" (click)="OnViewMoreClick()" *ngIf="isShowViewMore">
            <div class="team-members-button">View More</div>
            <img class="flag-icon arrow-icon" src="../../../assets/images/about-us/bule-arrow-down.svg" />
        </div>
        <div class="flex" (click)="OnCollapseAllClick()" *ngIf="!isShowViewMore">
            <div class="team-members-button">Collapse All</div>
            <img class="flag-icon arrow-icon" src="../../../assets/images/about-us/bule-arrow-up.svg" />
        </div>
    </div>
    <div class="flex justify-center items-center view-all-container view-all-container-mobile" *ngIf="totalCount > MAX_RESULT_COUNT_FOR_MOBILE">
        <div class="flex" (click)="OnViewMoreClick()" *ngIf="isShowViewMore">
            <div class="team-members-button">View More</div>
            <img class="flag-icon arrow-icon" src="../../../assets/images/about-us/bule-arrow-down.svg" />
        </div>
        <div class="flex" (click)="OnCollapseAllClick()" *ngIf="!isShowViewMore">
            <div class="team-members-button">Collapse All</div>
            <img class="flag-icon arrow-icon" src="../../../assets/images/about-us/bule-arrow-up.svg" />
        </div>
    </div>
</div>
